// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oQBgQ3b2QHsHt_DsMjld{flex-direction:column;width:532px;max-width:100%;display:flex}.kRck6DIgg7cy5rRdO64z{padding-left:0}.pBLeB46MNUQwUE73WA6T{flex-direction:column;gap:24px;display:flex}.x7JHpELpU03utP4cvZfU{gap:12px;display:flex}.VCAoraNn_VQEeQgW5NTv{flex:1;min-width:0}.LYXnA8fIJHgHx7_JIsKQ{height:55px}.H1LxRoWjPhgTY10QSkyh{flex-direction:column;gap:4px;display:flex}.evmVKGvj8ooaBnPoe1xu{text-align:center;padding:22px 0}.ayLxhDXexbAMrkWBEU46{color:var(--content-brand-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oQBgQ3b2QHsHt_DsMjld`,
	"tabs": `kRck6DIgg7cy5rRdO64z`,
	"form": `pBLeB46MNUQwUE73WA6T`,
	"row": `x7JHpELpU03utP4cvZfU`,
	"rowItem": `VCAoraNn_VQEeQgW5NTv`,
	"einItem": `LYXnA8fIJHgHx7_JIsKQ`,
	"einOption": `H1LxRoWjPhgTY10QSkyh`,
	"noResults": `evmVKGvj8ooaBnPoe1xu`,
	"enterManuallyButton": `ayLxhDXexbAMrkWBEU46`
};
export default ___CSS_LOADER_EXPORT___;
